export default {
  nav: { home: "Home", treatments: "Treatments", about: "About me", studio: "Studio", contact: "Contact" },
  cta: {
    book: "Book an appointment",
    discover: "Discover treatments",
    moreAbout: "More about me",
    allTreatments: "All treatments",
    send: "Send enquiry",
    sending: "Sending…",
    call: "Call now",
    whatsapp: "Write on WhatsApp",
    backHome: "Back to home",
    discoverStudio: "Discover the studio",
    request: "Request an appointment",
    readMore: "Learn more",
  },
  header: { openMenu: "Open menu", closeMenu: "Close menu", languageLabel: "Choose language" },
  home: {
    heroEyebrow: "Beauty & Wellness · Basel",
    heroLines: ["Beauty.", "Relaxation.", "Well-being."],
    heroWelcomePre: "Welcome to",
    heroWelcomeBrand: "IMPERIUM.",
    heroSub: "Professional cosmetics and soothing massages for more radiance, calm and well-being.",
    heroQuote: "“Personal care, high-quality treatments and an atmosphere in which you can completely arrive within yourself.”",
    trustNo: "01",
    trustEyebrow: "Trust",
    trustTitle: "Beauty begins with trust.",
    trustText: "Your skin, your body and your well-being deserve attention. At IMPERIUM, professional treatment, personal consultation and an atmosphere come together in which you can feel completely at ease.",
    trustPoints: ["Personal care", "Individual treatment", "Refined atmosphere", "Professional cosmetics", "Time for your needs"],
    servicesNo: "02",
    servicesEyebrow: "Treatments",
    servicesTitle: "What would you like to take centre stage today?",
    servicesIntro: "Massage, cosmetics and styling – every treatment individually tailored to you.",
    auszeitNo: "03",
    auszeitEyebrow: "Your time out",
    auszeitTitle: "Your time out begins the moment you choose yourself.",
    auszeitText: "Leave everyday life behind for a moment. Feel calm, care and renewed energy – tailored to you.",
    ablaufEyebrow: "How it works",
    ablaufTitle: "How easily your Imperium moment begins",
    steps: [
      { t: "Choose your treatment", d: "Discover what would do you good today." },
      { t: "Get in touch", d: "Simply via form, WhatsApp or phone call." },
      { t: "Receive personal advice", d: "Everything is tailored to you and your wishes." },
      { t: "Arrive relaxed", d: "You step in and everyday life stays outside." },
      { t: "Enjoy your treatment", d: "Your Imperium moment – all for you." },
    ],
    expertNo: "04",
    expertEyebrow: "Your expert",
    expertName: "Leidiane Alcântara",
    expertText: "Aesthetics and well-being professional – with dedication, continuous training and an attentive eye for the individual needs of every person.",
    studioNo: "05",
    studioEyebrow: "The studio",
    studioTitle: "A space created with love for detail.",
    studioText: "In Basel, IMPERIUM Beauty & Wellness is coming to life – a modern, elegant and comfortable studio, created for a complete experience of beauty, care and well-being.",
    galleryEyebrow: "Gallery",
    galleryTitle: "Glimpses into the world of IMPERIUM",
    finalTitle: "Ready for your most beautiful time out?",
    finalText: "Take some time for yourself. I look forward to meeting you in person.",
    marquee: ["Aesthetics", "Massage", "Lymphatic drainage", "Facial care", "Make-up", "Well-being"],
  },
  treatmentsPage: {
    eyebrow: "Treatments",
    title: "Your treatments at IMPERIUM",
    intro: "Massage, cosmetics and styling – discover what would do you good today. Every treatment is individually tailored to you.",
    massage: "Massage & Body",
    beauty: "Cosmetics & Styling",
  },
  treatment: {
    back: "All treatments",
    related: "Further treatments",
    ctaTitle: "Request this treatment",
    ctaText: "Tell me about your wishes – I will advise you personally and together we will find your Imperium moment.",
  },
  about: {
    eyebrow: "About me",
    title: "Leidiane Alcântara",
    role: "Aesthetics & Well-being",
    bio: [
      "I am Leidiane Alcântara, an aesthetics and well-being professional – passionate about caring for people and bringing out the most beautiful in each of them.",
      "With dedication, continuous training and an attentive eye for individual needs, I have built my path with hard work, responsibility and love for what I do.",
      "I believe that every person is unique. That is why I offer personal care with modern and safe techniques – always prioritising care, aesthetics and well-being.",
    ],
    storyEyebrow: "The story",
    storyTitle: "The dream of IMPERIUM",
    story: [
      "Now I am fulfilling a great dream: I am opening IMPERIUM Beauty & Wellness – a beautiful studio, created especially to offer a complete experience of beauty, care and well-being.",
      "Every detail is being prepared with great love, so that every client feels welcomed, valued and experiences a unique moment in a modern, elegant and comfortable setting.",
      "It will be a place where aesthetics, relaxation and self-esteem come together – because caring for you is my greatest mission.",
    ],
    quote: "“Caring for you is my greatest mission.”",
    philosophyEyebrow: "Philosophy",
    philosophyTitle: "Every person is unique.",
    philosophyText: "Personal care, modern and safe techniques – always with a focus on care, aesthetics and well-being.",
    ctaTitle: "Let's get to know each other.",
    ctaText: "I look forward to your message – personal, uncomplicated and without obligation.",
  },
  studio: {
    eyebrow: "Studio",
    title: "IMPERIUM in Basel",
    intro: "A studio created for beauty, care and well-being – modern, elegant and comfortable.",
    preparing: "The studio is currently being prepared with great love for detail. Every corner is created with the aim that you feel welcome and valued from the very first moment.",
    locationLabel: "Location",
    location: "Austrasse 31, 4051 Basel, Switzerland",
    ctaTitle: "Be part of it from the very beginning.",
    ctaText: "Write to me – I look forward to hearing from you.",
  },
  contact: {
    eyebrow: "Contact",
    title: "Your Imperium moment begins here.",
    intro: "Question, wish or appointment – write to me. I will reply personally.",
    locationLabel: "Location",
    phoneLabel: "Phone & WhatsApp",
    emailLabel: "E-mail",
    instagramLabel: "Instagram",
    formTitle: "Send an enquiry",
  },
  form: {
    name: "First & last name",
    email: "E-mail",
    phone: "Phone (optional)",
    treatment: "Treatment",
    treatmentPlaceholder: "Select a treatment",
    noPreference: "Not sure yet / Consultation",
    message: "Message",
    messagePlaceholder: "How can I help you?",
    privacy: "I have read the privacy policy and agree to the processing of my details in order to answer my enquiry.",
    submit: "Send enquiry",
    sending: "Sending…",
    success: "Thank you very much! Your enquiry has arrived. I will get back to you personally as soon as possible.",
    error: "Unfortunately an error occurred. Please try again or write to me on WhatsApp.",
    required: "Please fill in all required fields.",
    invalidEmail: "Please enter a valid e-mail address.",
    privacyRequired: "Please confirm the privacy policy.",
  },
  footer: {
    tagline: "Aesthetics · Massage · Well-being",
    navTitle: "Navigation",
    treatmentsTitle: "Treatments",
    contactTitle: "Contact",
    legalTitle: "Legal",
    impressum: "Imprint",
    privacy: "Privacy",
    rights: "All rights reserved.",
    location: "Austrasse 31, 4051 Basel, Switzerland",
  },
  impressum: {
    title: "Imprint",
    operatorLabel: "Operator",
    operator: "IMPERIUM Beauty & Wellness — Leidiane Alcântara",
    contactLabel: "Contact",
    contentLabel: "Responsible for content",
    note: "Further legal information is currently being completed and will be added shortly.",
  },
  privacyPage: {
    title: "Privacy Policy",
    responsibleTitle: "Responsible party",
    responsibleText: "IMPERIUM Beauty & Wellness — Leidiane Alcântara, Austrasse 31, 4051 Basel, Switzerland.",
    dataTitle: "Data via the contact form",
    dataText: "When you write to me via the form, your details (name, e-mail, phone, message) are used exclusively to answer your enquiry and are not passed on to third parties.",
    storageTitle: "Browser storage",
    storageText: "This website only stores your language choice and your cookie decision locally in your browser. No tracking cookies are set.",
    rightsTitle: "Your rights",
    rightsText: "You have the right at any time to access, correct or delete your data. Simply write to kontakt@imperium-wellness.ch.",
  },
  google: { label: "IMPERIUM on Google", rate: "Rate on Google", reviews: "See reviews" },
  notfound: {
    title: "404",
    heading: "This page could not be found.",
    text: "Perhaps you will find what you are looking for here:",
  },
  cookie: {
    text: "This website only uses technically necessary storage – for example for your language choice. No tracking cookies are set.",
    accept: "Understood",
    more: "Privacy",
  },
  seo: {
    homeTitle: "IMPERIUM Beauty & Wellness | Cosmetics, Aesthetics & Massages in Basel",
    homeDesc: "Professional cosmetics and soothing massages for more radiance, calm and well-being. Your beauty. Your moment. Your Imperium.",
  },
};
